/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-regex-spaces */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
import './style.css';

import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { redirectToCheckout } from '../../helpers/pricing';
import { selectAppState } from '../../utils/appReducer';
import { Loading } from '../../pages/Profile/Loading';
import { AuthScreenHint, BillingTerms } from '../../consts';


const GoToOrder: React.FC = () => {
  const location = useLocation<Location>();

  const { licenseData } = useSelector(selectAppState);

  const {
    user,
    isLoading,
    isAuthenticated,
    loginWithRedirect
  } = useAuth0();

  const { pathname, search } = window.location;

  const query = new URLSearchParams(location.search);

  const billingTerm = (
    query.has('billingTerm') ? query.get('billingTerm') : BillingTerms.ANNUAL
  ) || BillingTerms.ANNUAL;

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (isAuthenticated && user?.email) {
      redirectToCheckout({
        email: user?.email ?? '',
        serialNumber: licenseData?.data.serialNumber ?? '',
        billingTerm
      });
    } else {
      loginWithRedirect({
        appState: { returnTo: pathname + search, billingTerm },
        screen_hint: AuthScreenHint.SIGN_UP
      });
    }
  }, [user, licenseData, isLoading, isAuthenticated, billingTerm]);

  return (
    <>
      <Loading />;
    </>
  );
};

export default GoToOrder;
